<template>
  <div class="v-select-identity-wrap">
    <!-- <div class="text-center v-title">
      {{ $t('Please select identity') }}
    </div> -->
    <div class="flex selectType">
      <div class="icon-box text-center icon-actor">
        <div
          class="v-cbox flex-center v-bg1 pointer"
          @click="selectLoginIdentity('ACTOR')"
        >
          <span class="iconfont iconzhanshang_weixuanzhong"></span>
        </div>
        <p class="actor-p f-w-b" v-if="$store.getters.language == 'zh'">{{ $t('myIndentity[0]') }}</p>
        <p class="actor-p" v-if="$store.getters.language == 'zh'">{{ $t('myIndentity[1]') }}</p>
        <p class="actor-p f-w-b" v-if="$store.getters.language == 'en'">{{ $t('myIndentity[0]') }}</p>
        <p class="actor-p" v-if="$store.getters.language == 'en'">{{ $t('myIndentity[1]') }}</p>
      </div>
      <div class="www text-center">
        <div class="icon-box text-center icon-vister">
          <div
            class="v-cbox flex-center v-bg2 pointer"
            @click="selectLoginIdentity('VISITOR')"
          >
            <span class="iconfont iconguanzhong_weixuanzhong" style="font-size: 36px"></span>
          </div>
          <p class="vister-p f-w-b" v-if="$store.getters.language == 'zh'">{{ $t('myIndentity[2]') }}</p>
          <p class="vister-p" v-if="$store.getters.language == 'zh'">{{ $t('myIndentity[3]') }}</p>
          <p class="vister-p f-w-b" v-if="$store.getters.language == 'en'">{{ $t('myIndentity[2]') }}</p>
          <p class="vister-p" v-if="$store.getters.language == 'en'">{{ $t('myIndentity[3]') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SelectIdentity', //选择身份
  mounted(){
    console.log(this.$store.state)
  },
  computed: {
    ...mapGetters(['subjectType', 'language'])
  },
  methods: {
    selectLoginIdentity(type) {
      if (type == 'ACTOR') {
        if (!this.ActorNoTodo()) return
        if(this.$store.getters.loginType == '') {
          this.$store.commit('SET_LOGIN_TYPE', 'phone')
        }
      }
      this.$store.commit('SET_SUBJECTTYPE', type)
      this.$emit('callback',{type:"switchComponents",path:"vLogin",status: type})
      this.hostAdvertisingSharingStatistics()
    }
  }
}
</script>
<style lang="stylus" scoped>

.v-select-identity-wrap{
    width:100%;
    max-width:414px;
    margin:0 auto;
    background blue
    .v-cbox{
        width:72px;
        height:72px;
        border-radius:50%;
        margin-bottom:40px;
        transition all .3s
        .iconfont{
            font-size:36px;
        }

        &:hover {
          opacity: .7;
        }
    }
    p{
        font-size:16px;
        // margin:8px 0;
    }
    .v-title{
        margin:23px 0 80px;
        line-height: 32px;
        font-size:22px;
    }
    .v-bg1{
       background:$color-main;
       color:$color-white;
       text-align: center;
      margin: 64px auto 12px;
    }
    .v-bg2{
      background: $color-visitor;
      color: $color-white;
      text-align: center;
      margin: 64px auto 12px;
    }
    .icon-box{
      width 120px 
    }
}
.selectType{
      position: absolute;
    bottom: 20px;
    background: $color-white;
    right: 0;
    width: 343px;
    height: 233px;
    border-radius: 150px 0 0 150px;
    box-shadow: 0px 2px 28px 0px rgba(4, 145, 184, 0.25);
}
.icon-actor{
  margin-left 42px;
}
.icon-vister{
  margin-left 55px;
}
.www{
  width 184px
  background $color-white  
  border-radius: 150px 0 0 150px;
  box-shadow: 0px 2px 28px 0px rgba(4, 145, 184, 0.25);
}
.vister-p{
  color $color-visitor;
}
.actor-p{
  color $color-main;
  }
</style>
